import { LightningHeroAdvantages } from './LightningHeroAdvantages';
import { LightningHeroBackgrounds } from './LightningHeroBackgrounds';
import { LightningHeroBenefits } from './LightningHeroBenefits';
import { LightningIntro } from './LightningIntro';

import './styles.scss';

/**
 * Lightning-themed hero section for locales that use the alternate layout (ro, pt, en).
 * Composes layered backgrounds, the intro block (header, title, Play CTA, checkbox,
 * phone mockup), benefits, and the advantages strip. Disables Play
 * until consent is ready; checkbox toggles emit design and basic GA events.
 *
 * @param {string} lang — Active locale key for polyglot strings (e.g. hero copy, alts).
 * @param {boolean} consentBannerReady — When false, the Play button stays disabled.
 * @param {() => void} onBtnClick — Handler for the primary Play CTA (e.g. phase switch / age gate).
 * @param {string} [videoUrl] — LP video URL; used only if LandingVideoProvider did not expose a hero slot ref.
 * @param {boolean} checked — Whether the user has confirmed age via the hero checkbox.
 * @param {Function} setChecked — React state setter paired with `checked` for the age checkbox.
 */
const HeroLightning = ({
    lang,
    consentBannerReady,
    onBtnClick,
    videoUrl,
    checked,
    setChecked,
}) => {
    return (
        <section className='lightning-hero'>
            <div className='lightning-hero__container'>
                <LightningHeroBackgrounds />

                <LightningIntro
                    lang={lang}
                    consentBannerReady={consentBannerReady}
                    onBtnClick={onBtnClick}
                    videoUrl={videoUrl}
                    checked={checked}
                    setChecked={setChecked}
                />

                <div className='lightning-hero__benefits-container'>
                    <LightningHeroBenefits lang={lang} />
                </div>

                <div className='lightning-hero__advantages-container'>
                    <LightningHeroAdvantages lang={lang} />
                </div>
            </div>
        </section>
    );
};

export default HeroLightning;
